import React from "react";

import { formatCurrency, formatPercentage } from "../../../../utils/namesFormater";
import { DataRowsDisplay } from "../../../../shared/UIParts/DataRowsDisplay";
import { LastDepositSummary } from "../../../../interfaces/DTO/mislaka_xml_models";
import { formatDepositType } from "../../../../utils/enumFormatter";


interface LastDepositSummaryDisplayProps {
  summary: LastDepositSummary;
}

const LastDepositSummaryDisplay: React.FC<LastDepositSummaryDisplayProps> = ({ summary }) => {
  if (!summary) return null;

const insurancePaid = summary.total_last_deposit - summary.total_last_saving_deposit;
  const insurancePercentage = summary.total_last_deposit > 0
    ? formatPercentage(insurancePaid / summary.total_last_deposit)
    : "לא זמין";

  const rows = [
    { label: "חודש ייחוס אחרון", value: summary.reference_month },
    { label: "סכום הפקדה אחרונה", value: formatCurrency(summary.total_last_deposit) },
    { label: "תאריך ערך הפקדה", value: summary.value_date },
    { label: "סוג הפקדה", value: formatDepositType(summary.deposit_type) },
    { label: "חלק ההפקדה השוטפת המופנה לחיסכון בפוליסת עדיף יסודי", value: formatCurrency(summary.saving_a) },
    { label: "חלק ההפקדה השוטפת המופנה לחיסכון טהור", value: formatCurrency(summary.saving_b) },
    { label: "סה\"כ לחיסכון נטו", value: formatCurrency(summary.total_last_saving_deposit) },
    { label: " סכום ששולם לביטוח ודמי ניהול", value: formatCurrency(insurancePaid) },
    { label: " אחוז ששולם לביטוח ודמי ניהול", value: insurancePercentage },
  ];

  return (
    <DataRowsDisplay
      title="פרטי סיכום הפקדה אחרונה"
      rows={rows}
    />
  );
};

export default LastDepositSummaryDisplay;
